import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormButton,
} from '@shared/components';

import { ItemSetQuestionChangeFormProvider } from '../../providers';
import { ItemSetQuestionChangeTableSection } from '../item-set-question-change-table-section';
import { QuestionChangeInformationSection } from '../question-change-information-section';

interface ItemSetQuestionChangeModalProps {
  questionId: string;
  qSetQuestionId: string;
  open: boolean;
  onClose: () => void;
  onComplete?: () => void;
}

export default function ItemSetQuestionChangeModal(
  props: Readonly<ItemSetQuestionChangeModalProps>,
) {
  const { questionId, qSetQuestionId, open: isOpen, onClose, onComplete } = props;

  const handleComplete = () => {
    onClose();
    onComplete?.();
  };

  return (
    <Dialog open={isOpen} maxWidth='lg' onClose={onClose}>
      <ItemSetQuestionChangeFormProvider
        qSetQuestionId={qSetQuestionId}
        onComplete={handleComplete}
      >
        <DialogTitle onClose={onClose}>Change Question</DialogTitle>
        <Divider />
        <DialogContent
          sx={(theme) => ({ display: 'flex', flexDirection: 'column', gap: theme.spacing(4) })}
        >
          <QuestionChangeInformationSection questionId={questionId} />
          <ItemSetQuestionChangeTableSection />
        </DialogContent>
        <Divider />

        <DialogActions>
          <Button size='large' variant='outlined' color='secondary' onClick={onClose}>
            Cancel
          </Button>
          <FormButton type='submit' label='Save' size='large' />
        </DialogActions>
      </ItemSetQuestionChangeFormProvider>
    </Dialog>
  );
}
